import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, Learner } from '../api';

interface SessionValue {
  learner: Learner | null;
  loading: boolean;
  refresh: () => Promise<void>;
  signOut: () => Promise<void>;
  setLearner: (l: Learner | null) => void;
}

const Ctx = createContext<SessionValue>({
  learner: null, loading: true, refresh: async () => {}, signOut: async () => {}, setLearner: () => {},
});
export const useSession = () => useContext(Ctx);

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const [learner, setLearner] = useState<Learner | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { learner } = await api.get<{ learner: Learner | null }>('/auth/me');
      setLearner(learner);
    } catch {
      setLearner(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void refresh(); }, [refresh]);

  const signOut = useCallback(async () => {
    await api.post('/auth/logout');
    setLearner(null);
  }, []);

  return (
    <Ctx.Provider value={{ learner, loading, refresh, signOut, setLearner }}>
      {children}
    </Ctx.Provider>
  );
}
